import { versionAtom } from "@app/store/versionStore";
import { FlexCol, FlexRow } from "@design-system/Layout/Flex";
import { useAtomValue } from "jotai";
import Loading from "../../../components/Loading";
import BottomLeftBlock from "./components/BottomLeftBlock";
import BottomRightBlock from "./components/BottomRightBlock";
import Header from "./components/Header";
import TopLeftBlock from "./components/TopLeftBlock";
import TopRightBlock from "./components/TopRightBlock";
import {
    SendForReviewModal,
    UnsendReviewRequestModal,
} from "./components/ValidationModal";
import {
    EditorContext,
    useCreateDocumentEditorContext,
} from "./hooks/useEditor";

import { usePageviewTrack } from "@app/shared/planhat";
import "./i18n";

const EditDocument = () => {
    const { data: { version } = { version: undefined }, isPending } =
        useAtomValue(versionAtom);

    const ctxValue = useCreateDocumentEditorContext(version);

    usePageviewTrack("pageview_document_edit");

    if (isPending) {
        return <Loading size="small" />;
    }

    return (
        <EditorContext.Provider value={ctxValue}>
            <FlexCol className="fixed top-0 left-0 h-screen w-screen bg-white overflow-scroll">
                <FlexCol className="h-screen overflow-hidden">
                    <Header />
                    <FlexRow className="min-h-0 flex-shrink flex-grow">
                        {version ? (
                            <>
                                <FlexCol className="border-r border-tertiary flex-grow h-full">
                                    <TopLeftBlock />
                                    <BottomLeftBlock />
                                </FlexCol>
                                <FlexCol className="w-[320px] min-h-0 flex-shrink h-full">
                                    <TopRightBlock />
                                    <FlexCol className="w-[320px] min-h-0 flex-shrink h-full">
                                        <BottomRightBlock />
                                    </FlexCol>
                                </FlexCol>
                            </>
                        ) : (
                            <Loading size="medium" />
                        )}
                    </FlexRow>
                </FlexCol>
            </FlexCol>
            <SendForReviewModal />
            <UnsendReviewRequestModal />
        </EditorContext.Provider>
    );
};

export default EditDocument;
